import React, { useState } from "react";
import "./LoginSignUp.css";
import user_icon from "../assets/person.png";
import login_icon from "../assets/login-image.jpg";
import email_icon from "../assets/email.png";
import password_icon from "../assets/password.png";
import { GoogleLogin } from "@react-oauth/google";
import { auth, provider } from "../../config/firebase";
import { signInWithPopup } from "firebase/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { config } from "../../config/const";
import glogo from "../assets/glogo.png";

export const LoginSignUp = () => {
  const navigate = useNavigate();
  let googlebuttonwidth = 470;
  const [user, setUser] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
  });

  const handleChange = (e) => {
    console.log(e);
    let name = e.target.name;
    let value = e.target.value;
    setUser({
      ...user,
      [name]: value,
    });
  };
  useEffect(() => {
    const email = localStorage.getItem("idToken");
    if (email) {
      setUser(email);
      navigate("/");
    }
  }, []);
  const handleGoogleSign = async () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        const { displayName, email } = user;
        user.getIdToken().then((idToken) => {
          localStorage.setItem("idToken", idToken);
          setUser(email);
          localStorage.setItem("email", email);
          localStorage.setItem("displayName", displayName);
          sendUserDataToBackend(displayName, email, idToken);
        });

        toast.success("Signed In Successfully", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark",
        });
        // localStorage.setItem("idToken",id);
      })
      .catch((error) => {
        console.error("Sign-in failed:", error);
        toast.error("Sign In Unsuccessful", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark",
        });
      });
  };

  const sendUserDataToBackend = (name, email, idToken) => {
    console.log("Sending data to backend");
    axios
      .post(
        `${config.backend_url}/login`,
        {
          name,
          email,
          idToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          mode: "cors",
        }
      )
      .then((response) => {
        if (response.status === 200) {
          navigate("/"); // Use history.push to redirect
        } else if (response.status === 201) {
          navigate("/login"); // Use history.push to redirect
        }
        console.log("User data sent to backend successfully");
      })
      .catch((error) => {
        console.error("Error sending user data to backend:", error);
        toast.error("Error sending user data to backend", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark",
        });
      });
  };

  return (
    <div className="container_">
      <div className="header">
        <div>
          <div className="text">Login</div>
          <div className="underline"></div>
        </div>
      </div>
      <div className="inputs_">
        <></>

        <></>

        <div>
          <div className="google-container">
            <button onClick={handleGoogleSign} className="google-button">
              <img src={glogo} alt="Google Icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
